import { Section, SectionTitle } from 'react-scale/components';
import Industries from 'react-scale/components/pages/document/industries-section';
import annotationTypes from 'react-scale/components/tailwind/product-examples/examples';

const IndustriesSection = ({ productType, product }) => (
  <Section bg="bg-[#050505]" id="industries">
    <SectionTitle
      marginBottom={false}
      overtitle="industries"
      title="Logistics, Finance, and Healthcare Depend On Us"
    />
    <div className="mt-28 md:mt-16">
      <Industries
        tabs={annotationTypes[productType]}
        product={product}
        highlightedButton
        buttonText="Run Extraction"
        color={{ instruction: 'text-[#F6F5FA]' }}
        theme="dark"
      />
    </div>
  </Section>
);

export default IndustriesSection;
